<template>
    <div class="Lllquery">
<!--        <div class="title">-->
<!--            <p class="return" @click="back">-->
<!--                <img src="~@public/img/user/login/jian.png"/>-->
<!--            </p>-->
<!--            机动车违法查询-->
<!--        </div>-->
        <div class="carType">
            <span style="width: 1.95rem">号牌种类</span>
            <van-dropdown-menu class="carType-menu">
                <van-dropdown-item v-model="carType" :options="carTypeOption"/>
            </van-dropdown-menu>
        </div>
        <div class="carCard">
            <span style="width: 2.9rem">号牌号码</span>
            <span>{{ province }}</span>
            <span>{{ carEnglish }}</span>
            <van-icon name="arrow" @click="showPickerCarCardType = true"/>
            <van-popup v-model="showPickerCarCardType" position="bottom">
                <van-picker show-toolbar :columns="carCardOptions" value-key="name" @cancel="showPickerCarCardType = false" @confirm="onConfirmCarCardType"/>
            </van-popup>
<!--            <van-dropdown-menu class="carType-menu">-->
<!--                <van-dropdown-item v-model="carCard" :options="carCardOptions"/>-->
<!--            </van-dropdown-menu>-->
            <van-field v-model="handlingId" placeholder="请输入号码" maxlength="6" class="carType-field"/>
        </div>

        <div class="carCard">
            <span style="width: 1.95rem">发动机号</span>
            <van-field v-model="engineNum" placeholder="请输入发动机号码后6位" maxlength="6" class="carType-field"/>
        </div>

        <van-cell-group>
            <!--<verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>-->
            <Vue2Verify ref="verify" v-if="show" @closeClick="show = false" @success='success'
                        :imgSize="{width:'310px',height:'155px'}"></Vue2Verify>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="submit">查询</van-button>
        </div>
        <div class="boxList" v-if="listShow"
             v-for="(item, index) in dataList" :key="index">
            <div class="boxList-item">
                <span>号牌号码:</span>
                <span>{{ item.HPHM }}</span>
            </div>
            <div class="boxList-item">
                <span>违法时间:</span>
                <span>{{ item.WFSJ }}</span>
            </div>
            <div class="boxList-item">
                <span>违法地址:</span>
                <span>{{ item.WFDZ.length > 15 ? item.WFDZ.substring(0,15) + '...': item.WFDZ}}</span>
            </div>
            <div class="boxList-item">
                <!--                <span>违法行为:</span>-->
                <!--                <span>{{ item.wfxwText }}</span>-->
                <van-cell title="违法行为:" :value=item.wfxwText size="large"/>
            </div>
            <div class="boxList-item">
                <span>处理标记:</span>
                <span>{{ item.cjbjText }}</span>
            </div>
            <div class="boxList-item">
                <span>交款标记:</span>
                <span>{{ item.jkbjText }}</span>
            </div>
        </div>
    </div>
</template>

<script>

    import {CellGroup, Field, Toast, Button, DropdownMenu, DropdownItem, Cell, Popup, Icon, Picker} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import {baseApiMap} from "@/api/base";
    import {queryApiMap} from "@/api/query";
    import {wfxwMap} from './dict/index'
    import { letterAndNumRegex } from '@/utils/regex'
    import Vue2Verify from "@/views/signUp/verify/verify"

    export default {
        name: "LicenseQuery",
        components: {
            Vue2Verify,
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Cell.name]: Cell,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Picker.name]: Picker,
        },
        data() {
            return {
                province: '鄂',
                carEnglish: 'A',
                showPickerCarCardType: false,
                carCardOptions: [
                    { id: 'A', name: 'A' },
                    { id: 'B', name: 'B' },
                    { id: 'C', name: 'C' },
                    { id: 'D', name: 'D' },
                    { id: 'E', name: 'E' },
                    { id: 'F', name: 'F' },
                    { id: 'G', name: 'G' },
                    { id: 'H', name: 'H' },
                    { id: 'J', name: 'J' },
                    { id: 'K', name: 'K' },
                    { id: 'L', name: 'L' },
                    { id: 'M', name: 'M' },
                    { id: 'N', name: 'N' },
                    { id: 'P', name: 'P' },
                    { id: 'Q', name: 'Q' },
                    { id: 'R', name: 'R' },
                    { id: 'S', name: 'S' }
                ],
                show: false,
                handlingId: '',//车牌号码
                engineNum: '', // 发动机号
                receiveVerificationCode: {}, // 接收验证码子组件传来verificationInfo对象
                value: '',
                carType: '',
                carTypeOption: [],
                jtwfxwMap: {},
                listShow: false, //查询结果的显示与隐藏
                dataList: [] //用于查询后存放数据
            }
        },
        mounted() {
            this.getCarType()
            this.getJtwfxw()
            this.logger.visit('113','0')
        },
        methods: {
            onConfirm(value) {
                this.value = value;
            },
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

            /**
             * 获取车辆类型
             */
            getCarType() {
                this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.vehicleType`).then(res => {
                    if (res.data.succ) {
                        const data = res.data.data
                        data.forEach(obj => {
                            if (obj.pid !== 'root') {
                                this.carTypeOption.push({
                                    text: obj.title, value: obj.val
                                })
                                this.carType = '02';
                            }
                        })
                    }
                })
            },

            /**
             * 获取交通违法字典表
             */
            getJtwfxw() {
                // this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dict.jtwfxf`).then(res => {
                //     if (res.data.succ) {
                //         const data = res.data.data
                //         data.forEach(obj => {
                //             if (obj.pid !== 'root') {
                //                 this.jtwfxwMap[obj.val] = obj.title
                //             }
                //         })
                //     }
                // })

                const wfxwDict = wfxwMap
                wfxwDict.forEach(obj => {
                    this.jtwfxwMap[obj.value] = obj.label
                })
            },
            /**
             * 选择车牌地方英文
             */
            onConfirmCarCardType(value) {
                // console.log(value)
                this.carEnglish = value.name
                this.showPickerCarCardType = false
            },
          submit() {
            if (!this.carType) {
              Toast('请选择车辆类型')
            } else if (!this.handlingId) {
              Toast('请输入号牌号码')
            } else if(!letterAndNumRegex(this.handlingId)) {
              Toast('请输入正确的号牌号码')
            } else if (!this.engineNum) {
              Toast('请输入发动机号')
            } else if(!letterAndNumRegex(this.engineNum)) {
              Toast('请输入正确的发动机号')
            } else {
              this.show=true
            }
          },

          async success(val) {
            Toast.loading({
              duration: 0,       // 持续展示 toast
              forbidClick: true, // 禁用背景点击
              loadingType: 'spinner',
              message: '查询中...'
            })
            try {
              const data = {
                carNum: this.province + this.carEnglish + this.handlingId.toUpperCase(),
                fdjh: this.engineNum,
                carType: this.carType,
                genGuid: val.captchaVerification,
                validCode: val.captchaVerification
              }
              const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.vehicleIllegal}`, data)
              this.show = false
              Toast.clear()
              if (res.data.succ) {
                const data = res.data.data.row
                this.dataList = Object.assign([], data)
                this.dataList.forEach(obj => {
                  obj.wfxwText = this.jtwfxwMap[obj.WFXW]
                  obj.cjbjText = obj.CLBJ === 0 ? '未处理' : '已处理'
                  obj.jkbjText = obj.JKBJ === 0 ? '未交款' : '未交款'
                })
                this.listShow = true
              } else {
                Toast.fail(res.data.msg)
              }
              this.logger.visit('113','1')
            } catch (error) {
              Toast.fail('服务器运行失败，请稍后再试。')
              console.log(error)
            }
          },

            /**
             * 点击查询
             */
            async query() {
                if (!this.carType) {
                    Toast('请选择车辆类型')
                } else if (!this.handlingId) {
                    Toast('请输入号牌号码')
                } else if(!letterAndNumRegex(this.handlingId)) {
                    Toast('请输入正确的号牌号码')
                } else if (!this.engineNum) {
                    Toast('请输入发动机号')
                } else if(!letterAndNumRegex(this.engineNum)) {
                    Toast('请输入正确的发动机号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            carNum: this.province + this.carEnglish + this.handlingId.toUpperCase(),
                            fdjh: this.engineNum,
                            carType: this.carType,
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.postCommonUtils(`${queryApiMap.vehicleIllegal}`, data)
                        if (res.data.succ) {
                            Toast.clear()
                            const data = res.data.data.row
                            this.dataList = Object.assign([], data)
                            this.dataList.forEach(obj => {
                                obj.wfxwText = this.jtwfxwMap[obj.WFXW]
                                obj.cjbjText = obj.CLBJ === 0 ? '未处理' : '已处理'
                                obj.jkbjText = obj.JKBJ === 0 ? '未交款' : '未交款'
                            })
                            this.listShow = true
                            // 清空验证码
                            this.$refs.childFunction.clearContent()
                            // 重新获取验证码
                            this.$refs.childFunction.interactionVerificationCode()
                        } else {
                            Toast.fail(res.data.msg)
                            // 清空验证码
                            this.$refs.childFunction.clearContent()
                            // 重新获取验证码
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                        this.logger.visit('113','1')
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            },
            back() {
                this.$router.go(-1);
            }
        }
    }
</script>
<style>
    .carType .van-dropdown-menu__title::after {
        position: absolute;
        top: 0.23rem;
        right: -4px;
        border: 3px solid;
        border-color: transparent transparent currentColor currentColor;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        opacity: .8;
        content: '';
    }
</style>
<style scoped>
    span{
        font-size: 0.37333rem;
    }
    .boxList {
        margin-bottom: 0.9rem;
    }
    .boxList-item {
        margin: 0 auto;
        width:90%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
    }
    .boxList-item span {
        font-size: 0.35rem;
        line-height: 1.2rem;
        color: #323233;
    }
    .boxList-item span:first-child {
        font-size: 0.35rem;
        width: 2rem;
        line-height: 1.2rem;
        color: #323233;
    }
    .title {
        padding: 20px 10px 10px 10px;
        height: 80px;
        font-size: 32px;
        color: #fff;
        background-color: #1989fa;
        position: relative;
        text-align: center;
    }
    .return img {
        font-size: 40px;
        width: 18px;
        height: 29px;
        position: fixed;
        left: 0.4rem;
        top: 0.35rem;
    }

    .carType {
        display: flex;
        line-height: 0.7rem;
        align-items: center;
    }

    .carType span {
        margin-left: 0.4rem;
    }

    .carType-menu {
        height: 1rem;
        margin-right: 3.15rem;
    }

    .carCard {
        display: flex;
        line-height: 0.7rem;
        border-bottom: 1px solid #fafbfb;
    }

    .carCard span {
        margin: 0.3rem 0 0 0.4rem;
    }

    .carType-van {
        height: 1rem;
    }

    .van-dropdown-menu__title::after {
          right: 0.4rem;
    }

    .carType-field {
        line-height: 0.8rem;
    }

    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
        border-width: 0;
    }

</style>
<style>

    .boxList-item .van-cell--large {
        padding: 0;
    }
    .carCard .van-icon{
        margin-top: 0.5rem;
        margin-left: 0.2rem;
    }
</style>
